import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.join";
import "core-js/modules/es.string.replace";
import { stringify } from 'querystring';
export var formatClassTime = function formatClassTime(timestamp) {
  return new Date(timestamp * 1e3).toISOString().replace(/[-:]|(\.\d{3})/g, '');
};
export var createLocationString = function createLocationString(address) {
  var addressLine = address.address_line1,
      city = address.city,
      state = address.state,
      zipCode = address.zip_code;
  return [addressLine, city, state, zipCode].filter(Boolean).join(', ');
};

var createGoogleCalendarEventLink = function createGoogleCalendarEventLink(name) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var address = arguments.length > 2 ? arguments[2] : undefined;
  var starttime = arguments.length > 3 ? arguments[3] : undefined;
  var endtime = arguments.length > 4 ? arguments[4] : undefined;
  return "https://www.google.com/calendar/render?action=TEMPLATE&".concat(stringify({
    text: name,
    dates: "".concat(formatClassTime(starttime), "/").concat(formatClassTime(endtime)),
    details: description,
    location: createLocationString(address)
  }), "&sf=true&output=xml");
};

export default createGoogleCalendarEventLink;